import AgTechMetric from '@agtech/web/components/Metrics/AgTechMetric';
import AgTechNoRecordsPage from '@agtech/web/components/Pages/Error/AgTechNoRecordsPage';
import { isLotInvoiced, isLotSold } from '@sales/data/lots/LotData';
import { SaleLotsDataProvider } from '@sales/data/lots/LotDataQueries';
import React from 'react'
import LotDialog from './dialogs/LotDialog';
import SaleLotSellingGrid from './components/grid/SaleLotSellingGrid';
import LotManagementDialog from './dialogs/LotManagementDialog';

const SaleLotOverviewPage = () => {
    return (
        <SaleLotsDataProvider>
            {(lotData) => {
                const saleLots = Object.values(lotData.lots);

                return saleLots.length > 0 ? (
                    <div className='stretched column-based flex'>
                        <div id='sale-lots-selling-grid' className='pr-3 flexed'>
                            <SaleLotSellingGrid lotData={lotData} />
                        </div>
                        <div className='tall row-based pl-3 gap-y-3 w-[240px] flex'>
                            <div id='sale-lots-in-sale-metric'>
                                <AgTechMetric
                                    header='Lots In Sale'
                                    value={saleLots.length.toString()}
                                />
                            </div>
                            <div id='sale-lots-sold-metric'>
                                <AgTechMetric
                                    header='Lots Sold'
                                    value={saleLots.filter(lot => isLotSold(lot)).length.toString()}
                                />
                            </div>
                            <div id='sale-lots-invoiced-metric'>
                                <AgTechMetric
                                    header='Lots Invoiced'
                                    value={saleLots.filter(lot => isLotSold(lot) && isLotInvoiced(lot)).length.toString()}
                                />
                            </div>
                            <div id='sale-lots-manage-btn' className='mt-auto'>
                                <LotManagementDialog.Button classes='button-block button-highlight w-full' />
                            </div>
                        </div>
                    </div>
                ) : (
                    <AgTechNoRecordsPage
                        message="We're sorry, there are no lots in the system for this sale."
                        action={{
                            prompt: 'To create one, click the button below',
                            button: () => <LotDialog.Button classes='button-highlight' />
                        }}
                    />
                );
            }}
        </SaleLotsDataProvider>
    )
}

export default SaleLotOverviewPage;
